module.exports = __webpack_public_path__ + "img/selected0-min.7c64f13a.png";